/* eslint-disable */

import request from '@/utils/request'
import qs from 'qs'
export function getListHistory(query) {
  return request({
    url: '/report-service/v1/history-report/list',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
export function getListHistoryExcel(query) {
  return request({
    url: '/report-service/v1/history-report/list-excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    },
    responseType: 'blob'
  })
}
